import { TrackEvent, useTracking } from '../../apps/professional-app/fa/common/tracking'

export const useTrackedMenuItem = (onItemClick?: () => void) => {
  const { tracked } = useTracking()

  const _handleMenuItemClick = (key: string) => {
    onItemClick?.()
  }

  return tracked(
    _handleMenuItemClick,
    { eventName: TrackEvent.MENU_ITEM_CLICKED },
    {
      eventDetailsExtractor: (key: string) => {
        return { menuItem: key }
      },
    },
  )
}
